import React, { useState, useEffect, useRef } from 'react';
import './Menu.css';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

function Menu() {
  const [pdfError, setPdfError] = useState(false);
  const [imgAvailable, setImgAvailable] = useState(false);
  const [imgChecked, setImgChecked] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  

  const imgRef = useRef(null);
  const pdfContainerRef = useRef(null);
  const pdfDocRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    const img = new Image();
    img.onload = () => { if (mounted) { setImgAvailable(true); setImgChecked(true); } };
    img.onerror = () => { if (mounted) { setImgAvailable(false); setImgChecked(true); } };
    img.src = '/cafea.jpg';
    return () => { mounted = false; };
  }, []);

  const renderPdf = async () => {
    setPdfLoading(true);
    setPdfError(false);
    const container = pdfContainerRef.current;
    if (!container) {
      setPdfLoading(false);
      return;
    }

    container.innerHTML = '';

    try {
      const loadingTask = pdfjsLib.getDocument('/cafea.pdf');
      const pdf = await loadingTask.promise;
      pdfDocRef.current = pdf;

      const availW = container.clientWidth || window.innerWidth;
      const outputScale = window.devicePixelRatio || 1;

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewportUnscaled = page.getViewport({ scale: 1 });
        const scale = availW / viewportUnscaled.width;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement('canvas');
        canvas.className = 'pdf-canvas';
        const ctx = canvas.getContext('2d');
        canvas.width = Math.floor(viewport.width * outputScale);
        canvas.height = Math.floor(viewport.height * outputScale);
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        ctx.setTransform(outputScale, 0, 0, outputScale, 0, 0);

        await page.render({ canvasContext: ctx, viewport }).promise;
        container.appendChild(canvas);
      }

      
    } catch (err) {
      console.error(err);
      setPdfError(true);
    } finally {
      setPdfLoading(false);
    }
  };

  useEffect(() => {
    if (imgChecked && !imgAvailable) {
      renderPdf();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgChecked, imgAvailable]);

  useEffect(() => {
    let resizeId = null;
    const handleResize = () => {
      if (imgAvailable) return; // image will scale naturally with width
      clearTimeout(resizeId);
      resizeId = setTimeout(renderPdf, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeId);
    };
  }, [imgAvailable]);

  return (
    <section className="menu-section">
      <div className="menu-container">
        <h2 className="section-title">Meniul Nostru</h2>

        <div className="menu-content">
          <div className="menu-pdf">
            <h3 className="visually-hidden">Meniu Complet</h3>
            <div className="pdf-viewer-wrapper">
              {imgChecked && imgAvailable ? (
                <img
                  ref={imgRef}
                  src="/cafea.jpg"
                  alt="Meniul Break Place"
                  className="menu-fullimage"
                />
              ) : pdfError ? (
                <div className="pdf-error">
                  <p>Nu am putut incarca PDF-ul</p>
                  <a href="/cafea.pdf" download className="download-btn">
                    Descarca PDF
                  </a>
                </div>
              ) : (
                <div ref={pdfContainerRef} className="pdf-container">
                  {pdfLoading && <div className="pdf-loading">Se încarcă...</div>}
                </div>
              )}
            </div>
            <div className="pdf-links">
              <a href="/cafea.pdf" download className="download-link">
                Descarca Meniu (PDF)
              </a>
              <a href="/cafea.pdf" target="_blank" rel="noopener noreferrer" className="view-btn">
                Deschide PDF
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Menu;
